import React, { Component } from 'react';
import './styles.scss';
import PropTypes from 'prop-types';
import i18n from 'utils/translate';
import Checkbox from 'components/Checkbox';

const propTypes = {
  checked: PropTypes.bool,
  onChange: PropTypes.func.isRequired
};

const defaultProps = {
  checked: false,
  onChange: console.log
};

class InfoTextHeader extends Component {
  render() {
    const { checked, onChange } = this.props;

    return (
      <div className="col-xs-12">
        <div className="info-text-wrapper">
          <p>
            {i18n(
              'Die Grazer Wechselseitige Versicherung Aktiengesellschaft, Herrengasse 18-20, 8010 Graz (kurz: GRAWE) ist ein als Aktiengesellschaft organisiertes Versicherungsunternehmen und bietet vor Vertragsabschluss Beratung an.'
            )}
          </p>
          <Checkbox
            id="infoCheckbox"
            name="acceptInfo"
            required
            checked={checked}
            label={i18n('Ich habe die Information zum Produktvertreiber gelesen.')}
            onChange={onChange}
          />
          <span>
            {i18n(
              'Weitere Informationen stehen zu einem späteren Zeitpunkt im Online-Formular zum Download zur Verfügung.'
            )}
          </span>
        </div>
      </div>
    );
  }
}

InfoTextHeader.defaultProps = defaultProps;
InfoTextHeader.propTypes = propTypes;

export default InfoTextHeader;
